export enum KnmAgreementStatusEnum {
  AGREEMENT_APPROVED = 'AGREEMENT_APPROVED',
  AGREEMENT_TERMINATED = 'AGREEMENT_TERMINATED',
  AGREEMENT_COMPLETED = 'AGREEMENT_COMPLETED',
  AGREEMENT_NOT_COMPLETED = 'AGREEMENT_NOT_COMPLETED',
}
